import { axios } from "../../lib/axios";

export const DeleteSales = (SalesId: string) => {
    return axios.delete(`/sales/${SalesId}`)
        .then(response => response.data);
};